import { getAuthHeaders } from '@/app/auth/getAuthHeaders'
import { client } from '@/shared/api/client'
import { assertValidVrmBlob } from '../lib/vrmBlobValidation'
import { getHubAvatarBlob } from './hub'
import { readAvatarApiErrorBody } from './response'

export const getAvatarVrm = async (avatarVersion: string): Promise<Blob> => {
  const header = await getAuthHeaders()
  const response = await client.api.avatar.vrm.$get(
    {
      header,
      query: { v: avatarVersion },
    },
    {
      init: {
        cache: 'no-store',
      },
    }
  )

  if (response.status === 204) {
    throw new Error('avatar not found')
  }

  if (!response.ok) {
    const body = await readAvatarApiErrorBody(response)
    throw new Error(body?.error ?? body?.message ?? `failed to fetch VRM: ${response.status}`)
  }

  const vrmBlob = await response.blob()
  await assertValidVrmBlob(vrmBlob, `avatar VRM API (version=${avatarVersion})`)
  return vrmBlob
}

export const getHubAvatarVrm = async (): Promise<Blob> => getHubAvatarBlob(getAuthHeaders)
